
import { View } from 'backbone';
import util from 'util/Util.js';
import nameTemplate from 'report/properties/main/chart-misc-accesibility.ejs';


class MainChartMiscAccessibilityView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]':'updateShowAllValues'
        };

        if(this.model.get('ignoreNull') === undefined){
            this.model.set('ignoreNull',true, {silent:true})
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateShowAllValues(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        this.model.set( propName, propVal );
    }



    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));

            let ignoreNull = util.isTrue(this.model.get('ignoreNull'));
            $(`input[name='ignoreNull']`).prop('checked', ignoreNull );
        }


        this.delegateEvents();
        return this;
    }

}

export default MainChartMiscAccessibilityView;
